import { Data$ } from '@lycoris-nubila/ngx-lycoris';

import { ICvTemplate } from 'domain/template/cv/cv-template';

export abstract class CvTemplateApplicationPort {
	public abstract observeCvTemplates(): Data$<ICvTemplate[]>;
}
